
import {of as observableOf, Observable} from 'rxjs';
import {AbstractExecutionStep} from '../../executor/abstract-execution-step';
import {ExecutionStepStatus} from '../../executor/execution-step-status';
import {HeaderComponent} from '../header.component';
import {Router} from '@angular/router';

export class ReselectProductExecutionStep extends AbstractExecutionStep {

  public doExecute(): Observable<ExecutionStepStatus> {
    const headerComponent: HeaderComponent = this.getPayload().getValue().component,
      product = this.getPayload().getValue().product;

    if (!headerComponent) {
      console.error('HeaderComponent not found!');
    }

    headerComponent.onChangeSelectedProduct(product);
    headerComponent.onChangeProduct({value: product});

    return observableOf({status: true, content: null});
  }

  private getRouter(): Router {
    return this.injector.get(Router, null);
  }
}
